import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import VasimBlockData from '../../../Models/Content/VasimBlockData';
// Import as any to avoid TypeScript issues with plain JS component
const VasimBlock: any = require('./VasimBlock.js').default;

export default class VasimBlockComponent extends EpiComponent<VasimBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <VasimBlock context={this.getContext()} iContent={this.props.data} />;
  }
}

